
//Représente les paramètres de synchronisation des cycles de vies des factures d’achat
export class AeFSynchroniserCyclesViesFacturesAchatParametres 
{
  //Identifiant de la session
  public identifiantSession!: string;

  //Identifiants des factures
  public identifiantsFactures!: string[];
}
